export enum EmployeeMarritalStatusEnum{
    MAARIED = 'MAARIED',
    UN_MARRIED ='UN MARRIED'
}